/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-09-27 11:12:37
 * @LastEditTime: 2022-02-28 22:33:58
 * @LastEditors: chenguobiao
 */
// import PersonalInfoPage from '@/render/views/personal/info'
// import PersonalOrderPage from '@/render/views/personal/order'
// import PersonalActivityPage from '@/render/views/personal/activity'
// import PersonalPaymentPage from '@/render/views/personal/payment'
// import PersonalAgreementPage from '@/render/views/personal/agreement'
// import PersonalRegistrationPage from '@/render/views/personal/registration'

// const PersonalInfoPage = () => import('@/render/views/personal/info')
// const PersonalOrderPage = () => import('@/render/views/personal/order')
// const PersonalActivityPage = () => import('@/render/views/personal/activity')
// const PersonalPaymentPage = () => import('@/render/views/personal/payment')
// const PersonalAgreementPage = () => import('@/render/views/personal/agreement')
// const PersonalRegistrationPage = () => import('@/render/views/personal/registration')
export default [{
  path: '/personal-info',
  name: 'PersonalInfo',
  component: resolve => require.ensure([], () => resolve(require('@/render/views/personal/info')), 'personal'),
  meta: {
    title: '国际象棋 - 个人信息',
    index: 0,
    keepAlive: false,
    auth: true,
  }
}, {
  path: '/personal-agreement',
  name: 'PersonalAgreement',
  component: resolve => require.ensure([], () => resolve(require('@/render/views/personal/agreement')), 'personal'),
  meta: {
    title: '国际象棋 - 购买协议',
    index: 1,
    keepAlive: false,
    auth: true,
  }
}, {
  path: '/personal-order',
  name: 'PersonalOrder',
  component: resolve => require.ensure([], () => resolve(require('@/render/views/personal/order')), 'personal'),
  meta: {
    title: '国际象棋 - 我的订单',
    index: 1,
    keepAlive: false,
    auth: true,
  }
}, {
  path: '/personal-activity',
  name: 'PersonalActivity',
  component: resolve => require.ensure([], () => resolve(require('@/render/views/personal/activity')), 'personal'),
  meta: {
    title: '国际象棋 - 活动列表',
    index: 2,
    keepAlive: false,
    auth: true,
  }
}, {
  path: '/personal-payment',
  name: 'PersonalPayment',
  component: resolve => require.ensure([], () => resolve(require('@/render/views/personal/payment')), 'personal'),
  meta: {
    title: '国际象棋 - 支付页面',
    index: 3,
    keepAlive: false,
    auth: true,
  }
}, {
  path: '/personal-registration',
  name: 'PersonalRegistration',
  component: resolve => require.ensure([], () => resolve(require('@/render/views/personal/registration')), 'personal'),
  meta: {
    title: '国际象棋 - 办证页面',
    index: 4,
    keepAlive: false,
    auth: true,
  }
}]
